import { BaseAction } from "../../../core/actions/BaseAction";
import { IUserResponse } from "../../../Orchestrator/Types/Index";
import { IStoreLastFmlmSearchParams } from "../../../Orchestrator/Types/Interface/ActionParams/StoreLastFmlmSearchActionParams";
import { LocationState } from "../../../Orchestrator/Types/Types/FmlmSearch/FmlmSearchType";
import { saveUserInformationAction } from "../../LogicActions/CommonActions/SaveUserInformationAction";

const MAX_LAST_SEARCH_LOCATIONS = 2;

class StoreLastFmlmSearchAction extends BaseAction<void, IStoreLastFmlmSearchParams> {

  private async storeLatestLocations(userData: IUserResponse, locationData: LocationState, isOrigin: boolean) {
    try {
      let lastSearchPayload = userData?.lastSearch || [];
      const isDuplicate = lastSearchPayload.some(
        (loc) =>
          loc.name === locationData.name &&
          loc.longitude === locationData.coordinates[0] &&
          loc.latitude === locationData.coordinates[1]
      );

      if (!isDuplicate) {
        lastSearchPayload = [
          {
            name: locationData.name,
            latitude: locationData.coordinates[1],
            longitude: locationData.coordinates[0],
            description: locationData.place_formatted.trim() || "",
            locationType: isOrigin ? "ORIGIN" : "DESTINATION",
          },
          ...lastSearchPayload,
        ]

        let lastSearchedOrigin = lastSearchPayload.filter(loc => loc.locationType.toLocaleLowerCase() === "origin").slice(0, MAX_LAST_SEARCH_LOCATIONS);
        let lastSearchDestination = lastSearchPayload.filter(loc => loc.locationType.toLocaleLowerCase() === "destination").slice(0, MAX_LAST_SEARCH_LOCATIONS);

        saveUserInformationAction.setParams({
          userData: userData,
          updatedUserData: {
            lastSearch: [...lastSearchedOrigin, ...lastSearchDestination],
          }
        })
        await saveUserInformationAction.execute()
      }
    } catch (error) {
      console.error("Error saving user information:", error);
    }
  }

  override async run() {
    const { userData, locationData, selectedExactLocation } = this.params!;

    const isOrigin = selectedExactLocation === "origin";

    if (userData) {
      await this.storeLatestLocations(userData, locationData, isOrigin);
    }
  }
}

export const storeLastFmlmSearchAction = new StoreLastFmlmSearchAction();
